import BaseApi from './BaseApi';

import { FilterDateParams } from 'models';

class TransactionsApi extends BaseApi {
	constructor() {
		super('/investor/transactions');
	}

	get({ params }: { params: FilterDateParams }) {
		return this.httpClient.get({
			conditions: { version: 'v2', auth: true },
			config: {
				params,
			},
		});
	}

	download({ params }: { params: FilterDateParams }) {
		return this.httpClient.get({
			conditions: { version: 'v2', auth: true },
			url: '/import',
			config: {
				params,
				responseType: 'blob',
			},
		});
	}
}

export const TransactionsService = new TransactionsApi();
